$(document).ready(function(){
    $(".accordion-toggle").on("click", function() {
        $(this).find(".collapse-plus,collapse-minus").toggle();
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/faq.js
// module id = 30
// module chunks = 0